import React, { useEffect, useRef, useState } from "react";
import './styles.css';
import gsap from 'gsap';
import Banners from "./Banners";
import Header from "pages/header/Header";
import Footer from "components/Footer";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Work from "../../components/work/Work";
import World from "../../components/World/World";
import FuelGrowth from "../../components/Business/Business";
import Testimonials from "components/Testimonial/Testimonial";
import CTASection from "components/CTA/Cta";

export default function Home1Page() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const pageRef = useRef(null);
  
  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const ctx = gsap.context(() => {
      const mm = gsap.matchMedia();

      gsap.fromTo(
        [".hero-badge", ".hero-title", ".hero-subtitle", ".hero-download-btn"],
        { autoAlpha: 0, y: 34 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1.1,
          ease: "power3.out",
          stagger: 0.12,
        }
      );

      mm.add("(max-width: 768px)", () => {
        gsap.fromTo(
          ".hero-phone-combined",
          { autoAlpha: 0, y: 120, scale: 0.90 },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.4,
            delay: 0.3,
            ease: "power4.out",
          }
        );

        gsap.to(".hero-phone-combined", {
          rotation: -1,
          duration: 2.2,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
          transformOrigin: "50% 60%",
        });
      });

      mm.add("(min-width: 769px)", () => {
        gsap.fromTo(
          ".hero-phone-combined",
          { autoAlpha: 0, y: 70, scale: 0.96 },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.25,
            delay: 0.2,
            ease: "power4.out",
          }
        );

        gsap.to(".hero-phone-combined", {
          y: -12,
          duration: 2.6,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
        });
      });

      gsap.fromTo(
        ".hero-highlight-card",
        { autoAlpha: 0, y: 24 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.12,
          delay: 0.35,
        }
      );

      const sections = gsap.utils.toArray(".landing-scroll-section");

      sections.forEach((section, index) => {
        if (index === 0) {
          return;
        }

        gsap.fromTo(
          section,
          { autoAlpha: 0, y: 90, scale: 0.985 },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.05,
            ease: "power3.out",
            scrollTrigger: {
              trigger: section,
              start: "top 84%",
              once: true,
            },
          }
        );

        const content = section.querySelectorAll(
          "h1, h2, h3, p, button, a, img, canvas"
        );

        if (content.length > 0) {
          gsap.fromTo(
            content,
            { autoAlpha: 0, y: 28 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.75,
              stagger: 0.04,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 78%",
                once: true,
              },
            }
          );
        }

        const parallaxTarget = section.querySelector("img, canvas");
        const speed = Number(section.getAttribute("data-speed") || 0.08);

        if (parallaxTarget) {
          gsap.fromTo(
            parallaxTarget,
            { yPercent: -4 },
            {
              yPercent: speed * 100,
              ease: "none",
              scrollTrigger: {
                trigger: section,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
              },
            }
          );
        }
      });

      return () => {
        mm.revert();
      };
    }, pageRef);

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <>
      <Header />
      <div ref={pageRef} className="w-full bg-white-A700" style={{ position: 'relative' }}>
        <div className="">
         
           {/* <Img src={Ellise} alt="image" object className="h-[200px]w-[100%] object-cover absolute" style={{position:'absolute',width:'70%'}} /> */}
          <div className="landing-page-animated">
            <section className="landing-scroll-section" >
              <Banners />
            </section>

            <section  >
              <Work />
            </section>
            <section >
              <World />
            </section>
            <section >
              <FuelGrowth />
            </section>

            <section >
              <Testimonials />
            </section>

            <section >
              <CTASection />
            </section>

            {/* <div className="flex w-[94%] flex-col items-center gap-[10px] px-[7px] pt-[7px] md:w-full md:gap-[75px] sm:gap-[50px]">
              <h2 className="animate-scroll-up text-[44px] md:text-[35px] font-[NeueMontreal] text-center">
                Why Choose Us <span className="text-[#EA352B]">?</span>
              </h2>
              <p className="w-[71%] text-[#000000] md:w-full font-[NeueMontreal] font-light text-[18px] md:text-[16px] leading-[1.5] pl-[0.5em] text-center">
                Welcome to Fuelingo, the ultimate tool to help you monitor your car’s fuel efficiency effortlessly. Whether you’re a daily commuter, road trip enthusiast, or business fleet manager, our app empowers you to make smarter decisions about your vehicle’s performance and fuel consumption.
              </p>
            </div> */}

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
